export enum FavoritterContext {
  MineVerktoy = 'mineVerktoy',
  FinnVerktoy = 'finnVerktoy',
}
